import { MutationTree } from 'vuex'
import { EstacionesState, StoreError, EstacionApi } from '@/store/modules/estaciones/types'
import { GrupoTipoVariableApi, TipoVariableApi } from './types'

export const mutations: MutationTree<EstacionesState> = {
  GRUPO_TIPO_VARIABLE_FETCHED (state, payload: GrupoTipoVariableApi[]) {
    state.error = { state: false }
    state.grupoTipoVariable = payload
  },
  TIPO_VARIABLE_FETCHED (state, payload: TipoVariableApi) {
    state.error = { state: false }
    state.tipoVariable = payload
  },
  ESTACIONES_FETCHED (state, payload: EstacionApi) {
    state.error = { state: false }
    state.estaciones = payload
  },
  DATA_ESTACION_FETCHED (state, payload: Array<{ fecha: string, valor: string }>) {
    state.error = { state: false }
    state.dataEstacion = payload
  },
  DATA_ESTACION_RESET (state) {
    state.error = { state: false }
    state.dataEstacion = []
  },
  DATA_ESTACION_GTV_FETCHED (state, payload) {
    state.error = { state: false }
    const { estacion_list = [] } = payload[0]
    state.estaciones.estacion_list = estacion_list
  },
  ESTACION_ERROR (state, payload: StoreError) {
    state.error = payload
  }
}
